import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'

export default function RelatedPathways({
  title = 'Continue Exploring Ecommerce Services',
  description = 'Connect this service with the platform, migration, optimization, and support expertise your store needs.',
  links,
  showBorders = false,
  centered = false,
  noBottomPadding = false,
  className = '',
}) {
  return (
    <section className={`mx-auto max-w-screen-xl px-5 md:px-10 ${noBottomPadding ? 'pt-14 sm:pt-16' : 'py-14 sm:py-16'} ${className}`}>
      <div className={`${showBorders ? 'border-y border-slate-200 ' : ''}${noBottomPadding ? 'pt-10' : 'py-10'}`}>
        <h2 className={centered ? 'text-center text-sm font-bold text-black' : 'text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl'}>
          {title}
        </h2>
        {description && <p className="mt-3 max-w-3xl leading-7 text-slate-600">{description}</p>}
        <div className={centered ? 'mt-5 flex flex-wrap justify-center gap-x-10 gap-y-3' : 'mt-7 grid gap-x-10 sm:grid-cols-2 lg:grid-cols-3'}>
          {links.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className={centered ? 'group flex w-full items-center justify-between gap-4 border-t border-slate-200 py-4 text-sm font-bold text-black transition-colors hover:border-vblue3 hover:text-vblue3 sm:w-80' : 'group flex items-center justify-between gap-4 border-t border-slate-200 py-4 font-semibold text-slate-900 transition-colors hover:border-vblue3 hover:text-vblue3'}
            >
              <span>{link.label}</span>
              <ArrowUpRight
                aria-hidden="true"
                className="size-5 shrink-0 text-slate-400 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-vblue3"
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
